var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTreeCaretClose = function SvgTreeCaretClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#9F9F9F",
    strokeWidth: 1.5,
    d: "M17.833 11.634a1 1 0 0 1 0 1.732l-7.5 4.33a1 1 0 0 1-1.5-.866V8.17a1 1 0 0 1 1.5-.866z"
  })));
};
export default SvgTreeCaretClose;